import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20creative%20agency%20office%20space%20with%20warm%20ambient%20lighting%2C%20artistic%20abstract%20wall%20art%2C%20contemporary%20furniture%2C%20large%20windows%20with%20soft%20natural%20light%2C%20warm%20coral%20and%20cream%20tones%2C%20professional%20yet%20inspiring%20atmosphere%2C%20editorial%20architectural%20photography%20style%2C%20clean%20lines%20with%20organic%20textures%2C%20subtle%20gradient%20lighting&width=1920&height=1080&seq=hero-bg-jelly-2026&orientation=landscape"
          alt="果冻传媒创意办公空间"
          className="w-full h-full object-cover object-top"
          title="果冻传媒创意内容营销与品牌传播平台"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-sm text-white/90 font-medium">累计服务 500+ 品牌，创造 50亿+ 品牌曝光</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
          用创意连接品牌与
          <br className="hidden md:block" />
          消费者
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          果冻传媒是专注创意内容生产与品牌传播的专业机构，提供短视频制作、社交媒体运营、广告策划及全案营销服务，用顶尖创意驱动品牌增长。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about#contact"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-base font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            获取合作方案
          </Link>
          <Link
            to="/category/short-video"
            className="px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm rounded-lg text-base font-medium transition-colors whitespace-nowrap cursor-pointer border border-white/20"
          >
            了解我们的服务
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {[
            { value: '500+', label: '服务品牌' },
            { value: '10万+', label: '产出内容' },
            { value: '50亿+', label: '累计曝光' },
            { value: '98%', label: '客户满意度' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stat.value}</div>
              <div className="text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}